import { render } from "./ProductModalSide.vue?vue&type=template&id=f635295c"
import script from "./ProductModalSide.vue?vue&type=script&lang=js"
export * from "./ProductModalSide.vue?vue&type=script&lang=js"

import "./ProductModalSide.vue?vue&type=style&index=0&id=f635295c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__